
<template>
  <v-container
    class="pa-0"
    style="max-width: 900px"
  >
    <v-toolbar
      flat
      color="white"
      class="mb-2"
    >
      <v-toolbar-title>{{ $t('Tools.Title') }}</v-toolbar-title>
    </v-toolbar>

    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('Tools.MergePrint') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <s-merge-print />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>

import SMergePrint from './components/SMergePrint'

export default {
  components: {
    SMergePrint
  }
}
</script>
